<template>
  <v-card>
    <v-card-title>QR読み取りフォーム QrReaderForm.vue</v-card-title>
    {{ rules }}{{ rulesFlag }}
    <v-card-text>
      <v-container>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ラベル"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rulesFlag[0]"
                label="読み取り後加工オプション"
              ></v-checkbox>
            </v-col>
            <v-col v-if="rulesFlag[0]" cols="3">
              <v-checkbox
                v-model="readToConvertHubFlags[0]"
                label="先頭からx文字切り取り"
              ></v-checkbox>
            </v-col>
            <v-col v-if="rulesFlag[0] && readToConvertHubFlags[0]" cols="3">
              <v-text-field
                label="切り取り文字数"
                v-model="rules[0]"
                :rules="[varidation.required]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="rules[1]"
                label="手入力有効"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        //共通値
        type: this.type,
        position: this.position,
        label: this.label,
        cols: this.cols,
        rule: this.rule,
      },
      rules: [0, 0],
      rulesFlag: [],
      readToConvertHubFlags: [],
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        numANDNot: (value) => {
          return /^[&!:0-9]*$/.test(value) || "数値か!のみ";
        },
        required: (value) => !!value || "必須項目です",
      },
    };
  },
  async mounted() {
    await this.getInit();
    //初期処理
  },
  methods: {
    async getInit() {
      if (typeof this.rule != "undefined") {
        this.rules = this.rule.split(",");
      }

      if (this.rules[0] != "") {
        this.readToConvertHubFlags[0] = true;
      }

      this.readToConvertHubFlags.forEach((hubFlag) => {
        if (hubFlag) {
          this.rulesFlag[0] = true;
        }
      });
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (
          this.rulesFlag[0] == false ||
          this.readToConvertHubFlags[0] == false
        ) {
          this.rules[0] = "";
        }
        this.returnData.rule = this.rules.join(",");
        this.$emit("clickSubmit", this.returnData);
      }
    },
  },
};
</script>
